import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

// material-ui
import { makeStyles } from '@mui/styles';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';

// project imports
import NavItem from './../NavItem';
import NavCollapse from './../NavCollapse';
import api from '../../../../../views/services/api';

// style constant
const useStyles = makeStyles((theme) => ({
    menuCaption: {
        ...theme.typography.menuCaption
    },
    subMenuCaption: {
        ...theme.typography.subMenuCaption
    },
    menuDivider: {
        marginTop: '2px',
        marginBottom: '10px'
    }
}));

//-----------------------|| SIDEBAR MENU LIST GROUP ||-----------------------//

const NavGroup = ({ item }) => {
    const classes = useStyles();

    const [accountType, setAccountType] = useState(null);
    const [menuOrder, setMenuOrder] = useState(null);
    // Flags de módulo aditivas - diferente de `accountType` (exclusivo,
    // uma conta é ecommerce OU imobiliária), essas são independentes:
    // qualquer conta pode ligar, sem trocar o tipo de negócio dela (ex:
    // Serviços - `Account.servicos_habilitado`, ligado em "Ajustes da
    // Conta"). Só uma flag por enquanto, não vale generalizar mais que
    // isso ainda.
    const [flags, setFlags] = useState({});

    useEffect(() => {
        (async () => {
            try {
                const res = await api.get('v1/apps/default/');
                const type = res.data?.app?.account_type || null;
                const servicesEnabled = Boolean(res.data?.app?.services_enabled);
                setAccountType(type);
                setMenuOrder(res.data?.app?.menu_order || null);
                // `catalog` é derivada (não vem do backend) - o hub
                // Produtos/Serviços aparece se a conta é ecommerce OU tem o
                // módulo de Serviços ligado, já que ele cobre os dois.
                setFlags({ services: servicesEnabled, catalog: type === 'ecommerce' || servicesEnabled });
            } catch (error) {
                setAccountType(null);
                setMenuOrder(null);
                setFlags({});
            }
        })();
    }, []);

    // Só o grupo "Painel" (utilities) pode ter ordem customizada pelo
    // cliente - os grupos "Sistema" e "Documentação Online" nunca passam
    // por aqui, então ficam sempre na ordem fixa definida no código.
    let children = item.children;
    if (item.id === 'utilities' && menuOrder && menuOrder.length) {
        const byId = new Map(item.children.map((menu) => [menu.id, menu]));
        const ordered = menuOrder.map((id) => byId.get(id)).filter(Boolean);
        const orderedIds = new Set(ordered.map((menu) => menu.id));
        const missing = item.children.filter((menu) => !orderedIds.has(menu.id));
        children = [...ordered, ...missing];
    }

    // menu list collapse & items
    const items = children
        .filter((menu) => !menu.requiresModule || menu.requiresModule === accountType)
        .filter((menu) => !menu.requiresFlag || flags[menu.requiresFlag])
        .map((menu) => {
            switch (menu.type) {
                case 'collapse':
                    return <NavCollapse key={menu.id} menu={menu} level={1} />;
                case 'item':
                    return <NavItem key={menu.id} item={menu} level={1} />;
                default:
                    return (
                        <Typography key={menu.id} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
            }
        });

    return (
        <React.Fragment>
            <List
                subheader={
                    item.title && (
                        <Typography variant="caption" className={classes.menuCaption} display="block" gutterBottom>
                            {item.title}
                            {item.caption && (
                                <Typography variant="caption" className={classes.subMenuCaption} display="block" gutterBottom>
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>

            {/* group divider */}
            <Divider className={classes.menuDivider} />
        </React.Fragment>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
